export default __webpack_public_path__ + "static/media/instagram_caption.2ab02de9.svg";